(function() {
    'use strict';


    HaqReviewOverviewController.$inject = ['$translate'];

    function HaqReviewOverviewController($translate) {
        var vm = this; //jshint ignore:line
        vm.rangeReviewText = '';
        init();

        function init() {
            vm.rangeReviewText = vm.rangeReview ? $translate.instant( 'ipmApp.landingPageHAQ.home.rangeReview.' + vm.rangeReview) : '';
        }
    }

    angular.module('ipmApp').component('haqReviewOverview', {
        bindings: {
            type: '<',
            patientName: '<',
            score: '<',
            scoreInterpretation: '<',
            rangeReview: '<'
        },
        templateUrl: 'app/qhp-workflow/haq-evaluation-workflow/review-overview.html',
        controller: HaqReviewOverviewController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
